export const NODE_ENV = process.env.NODE_ENV
export const REACT_APP_ENV = process.env.REACT_APP_ENV
export const REACT_APP_BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL
export const REACT_APP_PORTAL_TOKEN = process.env.REACT_APP_PORTAL_TOKEN
export const ASSET_PATH = process.env.ASSET_PATH
export const REFORGE_FRONTEND_SDK_KEY = process.env.REFORGE_FRONTEND_SDK_KEY
export const METABASE_URL = process.env.METABASE_URL

export const ADMIN_APP_VERSION = require('../package.json').version

let Auth0Credentials = {}

Auth0Credentials = JSON.parse(process.env.AUTH0_CREDENTIALS)

export const REACT_APP_AUTH0_DOMAIN = Auth0Credentials.AUTH0_DOMAIN
export const REACT_APP_AUTH0_CLIENT_ID = Auth0Credentials.AUTH0_CLIENT_ID
export const REACT_APP_AUTH0_REDIRECT_URI = Auth0Credentials.AUTH0_REDIRECT_URI

export const dpTypes = [
  'Business Card',
  'Door Hanger',
  'Event Flyer',
  'Flyer',
  'Postcard',
  'Printed Coupon',
  'Stickers'
]
export const bcTypes = [
  'Name and Position',
  'Name and Position - Color',
  'Name and Position - CSAT',
  'Fill in the Blank',
  'Fill in the Blank - Color',
  'Fill in the Blank - CSAT',
  'TW Wireless - Name',
  'TW Wireless - Blank',
  'WS With Address',
  'WS Without Address',
  'PE Appointment Card',
  'PE Address with Title',
  'PE Address without Title'
]
export const flyerTypes = [
  'Default',
  'T-MO Welcome Kit',
  'PE Now Open',
  'PE Opening Soon',
  'PE Event Handout',
  'PE Evergreen',
  'PE Leave Behind - Opening Soon',
  'PE Direct Mail - Opening Soon'
]
export const pdfTypes = ['Add-on', 'Artwork', 'Coupon']
export const poStatuses = ['Unsent', 'Sent', 'Partial', 'Received', 'Cancelled']
export const configVariantDisplayTypes = ['Dropdown', 'Swatch', 'Button']

export const COLORS = {
  primary: '#2b5995',
  fontPrimary: '#0e0e0e'
}

// define routes that skip session check
export const SESSION_ROUTES = ['login', 'auth0', 'sso-log-in', 'reset_password', 'auth0_callback']

export const THROTTLE_DELAY = 500

export const TOASTR_TIMEOUT = 8000

export const COOP_ENABLED = false
export const fulfillmentTypes = ['Warehouse', '3PL', 'Non-physical', 'Dropship'].map(e => ({ label: e, value: e }))
export const shippableTypes = ['No-Ship', 'Normal-Ship', 'First-Address-Ship', 'Digital Delivery'].map(type => ({
  label: type,
  value: type
}))

export const proofOutputFormats = [
  { label: 'PDF', value: 'pdf' },
  { label: 'PNG', value: 'png' },
  { label: 'JPEG', value: 'jpeg' }
]

export const proofOutputScales = [
  { label: 'Small', value: 50 },
  { label: 'Original', value: 100 },
  { label: 'Large', value: 150 },
  { label: 'Extra Large', value: 200 }
]

/** Selected format from proof_output_options (single select for now). */
export const getProofOutputFormat = proofOutputOptions => proofOutputOptions?.[0] || 'pdf'

/** Store one format in array until multiselect is supported. */
export const toProofOutputOptions = format => [format]

export const HARD_CODED_CARRIERS = [
  {
    label: 'USPS (Stamps.com)',
    carrier_code: 'stamps_com',
    services: [
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_priority_mail',
        name: 'USPS Priority Mail',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_priority_mail_express',
        name: 'USPS Priority Mail Express',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_parcel_select',
        name: 'USPS Parcel Select Ground',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_first_class_mail',
        name: 'USPS First Class Mail',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_media_mail',
        name: 'USPS Media Mail',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_ground_advantage',
        name: 'USPS Ground Advantage',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_priority_mail_international',
        name: 'USPS Priority Mail Intl',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_priority_mail_express_international',
        name: 'USPS Priority Mail Express Intl',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'usps_first_class_mail_international',
        name: 'USPS First Class Mail Intl',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'globalpost_economy',
        name: 'GlobalPost Economy Intl',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'globalpost_priority',
        name: 'GlobalPost Standard Intl',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'gp_plus',
        name: 'GlobalPost Plus',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'stamps_com',
        service_code: 'globalpost_parcel_select_smart_saver',
        name: 'GlobalPost Parcel Select SmartSaver',
        domestic: true,
        international: false
      }
    ]
  },
  {
    label: 'FedEx',
    carrier_code: 'fedex',
    services: [
      {
        carrier_code: 'fedex',
        service_code: 'fedex_international_priority_express',
        name: 'FedEx International Priority Express®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_ground',
        name: 'FedEx Ground®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_home_delivery',
        name: 'FedEx Home Delivery®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_2day',
        name: 'FedEx 2Day®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_2day_am',
        name: 'FedEx 2Day® A.M.',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_express_saver',
        name: 'FedEx Express Saver®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_standard_overnight',
        name: 'FedEx Standard Overnight®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_priority_overnight',
        name: 'FedEx Priority Overnight®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_first_overnight',
        name: 'FedEx First Overnight®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_smartpost_bound_printed_matter',
        name: 'FedEx SmartPost® Bound Printed Matter',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_smartpost_media',
        name: 'FedEx SmartPost® Media',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_smartpost_parcel_select',
        name: 'FedEx SmartPost parcel select',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_smartpost_parcel_select_lightweight',
        name: 'FedEx SmartPost parcel select lightweight',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_smartpost_returns',
        name: 'FedEx SmartPost® Returns',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_1_day_freight',
        name: 'FedEx 1Day® Freight',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_economy_international',
        name: 'FedEx International Economy®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_2_day_freight',
        name: 'FedEx 2Day® Freight',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_3_day_freight',
        name: 'FedEx 3Day® Freight',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_first_overnight_freight',
        name: 'FedEx First Overnight® Freight',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_ground_international',
        name: 'FedEx International Ground®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_international_economy',
        name: 'FedEx International Economy®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_international_priority',
        name: 'FedEx International Priority®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_international_first',
        name: 'FedEx International First®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_europe_first',
        name: 'FedEx Europe First®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_international_economy_freight',
        name: 'FedEx International Economy® Freight',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_international_priority_freight',
        name: 'FedEx International Priority® Freight',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_freight_priority',
        name: 'FedEx Freight® Priority',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_international_connect_plus',
        name: 'FedEx International Connect Plus®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_regional_economy',
        name: 'FedEx® Regional Economy',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_regional_economy_freight',
        name: 'FedEx® Regional Economy Freight',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_priority_express',
        name: 'FedEx® Priority Express',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_priority',
        name: 'FedEx® Priority',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'fedex',
        service_code: 'fedex_first',
        name: 'FedEx® First',
        domestic: true,
        international: false
      }
    ]
  },
  {
    label: 'UPS',
    carrier_code: 'ups',
    services: [
      {
        carrier_code: 'ups',
        service_code: 'ups_economy_ddp',
        name: 'UPS™ Economy DDP',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_standard_international',
        name: 'UPS Standard®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_next_day_air_early_am',
        name: 'UPS Next Day Air® Early',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_worldwide_express',
        name: 'UPS Worldwide Express®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_next_day_air',
        name: 'UPS Next Day Air®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_ground_international',
        name: 'UPS Ground® (International)',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_worldwide_express_plus',
        name: 'UPS Worldwide Express Plus®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_next_day_air_saver',
        name: 'UPS Next Day Air Saver®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_worldwide_expedited',
        name: 'UPS Worldwide Expedited®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_2nd_day_air_am',
        name: 'UPS 2nd Day Air AM®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_2nd_day_air_international',
        name: 'UPS 2nd Day Air® (International)',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_2nd_day_air',
        name: 'UPS 2nd Day Air®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_worldwide_saver',
        name: 'UPS Worldwide Saver®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_3_day_select',
        name: 'UPS 3 Day Select®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_ground',
        name: 'UPS® Ground',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_express_early_am',
        name: 'UPS Express Early A.M. to the U.S.',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_standard',
        name: 'UPS Standard®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_worldwide_expedited',
        name: 'UPS Expedited',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_worldwide_saver',
        name: 'UPS Worldwide Saver®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_next_day_air_international',
        name: 'UPS Next Day Air® (International)',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_3_day_select',
        name: 'UPS 3 Day Select®',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_express',
        name: 'UPS Express®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_express_noon',
        name: 'UPS Express® 12:00',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_economy_ddu',
        name: 'UPS™ Economy DDU',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_express_plus',
        name: 'UPS Express Plus®',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'ups',
        service_code: 'ups_express_na1',
        name: 'UPS Express (NA1)',
        domestic: false,
        international: true
      }
    ]
  },
  {
    label: 'DHL Express',
    carrier_code: 'dhl_express',
    services: [
      {
        carrier_code: 'dhl_express',
        service_code: 'express_worldwide_documents',
        name: 'Express Worldwide Documents',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'dhl_express',
        service_code: 'dhl_express_worldwide_eu',
        name: 'Express Worldwide EU',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'dhl_express',
        service_code: 'dhl_domestic_express',
        name: 'Domestic Express',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'dhl_express',
        service_code: 'economy_select',
        name: 'Economy Select',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'dhl_express',
        service_code: 'express_worldwide',
        name: 'Express Worldwide',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'dhl_express',
        service_code: 'express_envelope',
        name: 'Express Envelope',
        domestic: false,
        international: true
      }
    ]
  },
  {
    label: 'Endicia',
    carrier_code: 'endicia',
    services: [
      {
        carrier_code: 'endicia',
        service_code: 'usps_first_class_mail',
        name: 'USPS First Class Mail',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_media_mail',
        name: 'USPS Media Mail',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_parcel_select',
        name: 'USPS Parcel Select Ground',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_ground_advantage',
        name: 'USPS Ground Advantage',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_priority_mail',
        name: 'USPS Priority Mail',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_priority_mail_express',
        name: 'USPS Priority Mail Express',
        domestic: true,
        international: false
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_first_class_package_international',
        name: 'USPS First Class Package Intl',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_first_class_mail_international',
        name: 'USPS First Class Mail Intl',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_priority_mail_international',
        name: 'USPS Priority Mail Intl',
        domestic: false,
        international: true
      },
      {
        carrier_code: 'endicia',
        service_code: 'usps_priority_mail_express_international',
        name: 'USPS Priority Mail Express Intl',
        domestic: false,
        international: true
      }
    ]
  }
]
